import * as React from 'react';
import { DragData, Droppable, DraggableItemTypes } from 'owa-dnd';
import { dropMailItem } from '../actions/dropActions';
import { MailListRowDragData } from 'owa-mail-types/lib/types/MailListRowDragData';
import { observer } from 'mobx-react-lite';
import { getDayViewDropTime } from 'owa-time-panel-dnd';
import { getSelectedView } from 'owa-calendar-list-settings';
import { getDropBoxDropState } from '../selectors/timePanelDndStoreSelectors';
import { setDayViewDropTime } from 'owa-time-panel-dnd';
export interface CalendarCreateDroppableProps {
    classNames?: string;
    children?: React.ReactNode;
}

/**
 * This component handles creating a meeting from items dropped on it.
 * For now, that's creating a meeting from email messages.
 */
const CalendarCreateDroppable: React.FunctionComponent<CalendarCreateDroppableProps> = observer(
    function CalendarCreateDroppable(props: CalendarCreateDroppableProps) {
        const { classNames, children } = props;
        const dropViewState = getDropBoxDropState();

        return (
            <Droppable
                dropViewState={dropViewState}
                canDrop={canCalendarDrop}
                onDrop={onCalendarDrop}
                classNames={classNames}
                greedy={true}>
                {children}
            </Droppable>
        );
    }
);

function canCalendarDrop(dragInfo: DragData): boolean {
    return dragInfo.itemType === DraggableItemTypes.MailListRow;
}

function onCalendarDrop(
    dragData: DragData,
    pageX: number,
    pageY: number,
    target?: HTMLElement
): void {
    switch (dragData.itemType) {
        case DraggableItemTypes.MailListRow:
            const mailListDragData = dragData as MailListRowDragData;
            switch (getSelectedView()) {
                case 'Agenda':
                    dropMailItem(mailListDragData, 'TimePanel_DragToAgendaReplyWithMeeting'); //automatically suggest time
                    break;
                case 'Day':
                    dropMailItem(
                        mailListDragData,
                        'TimePanel_DragToDayReplyWithMeeting',
                        getDayViewDropTime()
                    ); //manually set time by drop location
                    setDayViewDropTime(null);
                    break;
            }
            break;
    }
}

export default CalendarCreateDroppable;
